import { allpeepNoPayloadEndpoint } from './helpers.js';
export const i18n = (rawClient) => ({
    translations: allpeepNoPayloadEndpoint(rawClient, '/i18n/:lang'),
    languages: allpeepNoPayloadEndpoint(rawClient, '/i18n/languages'),
});
